/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolWhatshotIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-whatshot"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 22.8Q9.43 22.8 7.25 21.71Q5.08 20.63 3.58 18.77L7.75 14.6L9.88 16.35Q10.28 16.68 10.79 16.64Q11.3 16.6 11.65 16.25L15.4 12.5L15.4 13.4Q15.4 13.95 15.79 14.34Q16.18 14.72 16.73 14.72Q17.27 14.72 17.66 14.34Q18.05 13.95 18.05 13.4L18.05 9.28Q18.05 8.72 17.66 8.34Q17.27 7.95 16.73 7.95L12.65 7.95Q12.1 7.95 11.71 8.34Q11.32 8.72 11.32 9.28Q11.32 9.82 11.71 10.21Q12.1 10.6 12.65 10.6L13.5 10.6L10.65 13.45L8.53 11.7Q8.13 11.38 7.61 11.41Q7.1 11.45 6.75 11.8L2.13 16.43Q1.68 15.4 1.44 14.3Q1.2 13.2 1.2 12Q1.2 9.75 2.05 7.78Q2.9 5.8 4.36 4.34Q5.83 2.88 7.79 2.04Q9.75 1.2 12 1.2Q14.25 1.2 16.23 2.04Q18.2 2.88 19.66 4.34Q21.13 5.8 21.96 7.78Q22.8 9.75 22.8 12Q22.8 14.25 21.96 16.21Q21.13 18.18 19.66 19.64Q18.2 21.1 16.23 21.95Q14.25 22.8 12 22.8Z" fill={color} />
    </svg>
  );
}
